import ContentPage from '~/src/pages/contentPage/ContentPage';
export default ContentPage;
